export const sendWAEventToParent = (options?: {
  linkExpired?: boolean;
  noProductsFound?: boolean;
  orderSuccessful?: boolean;
  unAuthorizedAccess?: boolean;
}) => {
  const {
    linkExpired = false,
    noProductsFound = false,
    orderSuccessful = false,
    unAuthorizedAccess = false,
  } = options || {};

  window.parent.postMessage(
    {
      source: 'iframe',
      type: 'BACK_TO_WHATSAPP_CLICKED',
      payload: {
        goBackToWhatsapp: true,
        linkExpired: linkExpired,
        noProductsFound: noProductsFound,
        orderSuccessful: orderSuccessful,
        unAuthorizedAccess: unAuthorizedAccess,
      },
    },
    '*'
  );
};
